import { useReducedMotion } from 'framer-motion'

/**
 * Returns animation props that respect prefers-reduced-motion.
 * When reduced motion is preferred, animations resolve instantly.
 */
export function useMotion() {
  const reduced = useReducedMotion()

  /** Standard section fade-up entrance */
  const sectionReveal = reduced
    ? { initial: {}, whileInView: {}, transition: {} }
    : {
        initial: { opacity: 0, y: 20 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.5, ease: [0.25, 1, 0.5, 1] },
      }

  /** Fade-only entrance (no movement) */
  const fadeReveal = reduced
    ? { initial: {}, whileInView: {}, transition: {} }
    : {
        initial: { opacity: 0 },
        whileInView: { opacity: 1 },
        transition: { duration: 0.6, ease: [0.25, 1, 0.5, 1] },
      }

  /** Hero stagger — returns props for a given delay index */
  const heroStagger = (index: number) =>
    reduced
      ? { initial: {}, animate: {}, transition: {} }
      : {
          initial: { opacity: 0, y: 24 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.6, delay: index * 0.1, ease: [0.25, 1, 0.5, 1] },
        }

  /** Horizontal slide (for code panels, etc.) */
  const slideIn = (direction: 'left' | 'right', delay = 0) =>
    reduced
      ? { initial: {}, whileInView: {}, transition: {} }
      : {
          initial: { opacity: 0, x: direction === 'left' ? -20 : 20 },
          whileInView: { opacity: 1, x: 0 },
          transition: { duration: 0.5, delay, ease: [0.25, 1, 0.5, 1] },
        }

  return { sectionReveal, fadeReveal, heroStagger, slideIn, reduced }
}
